module.exports = __webpack_public_path__ + "static/img/R3D.2f53eaa2.png";